import { HttpClient } from '@adapters/HttpClient';

function normStr(v: unknown): string {
  if (v == null) return '';
  return String(v).trim();
}

function numCostForm(coste: string): number {
  const t = coste.trim();
  if (t === '') return 0;
  const n = Number(t);
  return Number.isNaN(n) ? 0 : n;
}

function numCostApi(v: unknown): number {
  if (v == null || v === '') return 0;
  const n = Number(v);
  return Number.isNaN(n) ? 0 : n;
}

export class ProductsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<{ id: string; name: string }[]> {
    const raw = await this.httpClient.get<any>('/products', { fields: 'basic' });
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((p: any) => ({
      id: String(p.id),
      name: p.name,
    }));
  }

  async createProduct({
    name,
    description,
    code,
    cost,
    categoryId,
    imageFile,
    length,
    heigth,
    width,
    weight,
    weight_unit,
    dimension_unit,
    batch_active,
    batch_type,
    tenantChildId,
  }: {
    name: string;
    description: string;
    code: string;
    cost: number;
    categoryId: string;
    imageFile?: File;
    length?: string;
    heigth?: string;
    width?: string;
    weight?: string;
    weight_unit?: string;
    dimension_unit?: string;
    batch_active?: boolean;
    batch_type?: string;
    tenantChildId?: number | null;
  }): Promise<any> {
    const formData = new FormData();
    if (name) formData.append('name', name);
    if (description) formData.append('description', description);
    if (code) formData.append('code', code);
    if (cost !== undefined && cost !== null && cost !== 0) formData.append('cost', String(cost));
    if (categoryId) formData.append('category_id', categoryId);
    if (imageFile) {
      formData.append('image_hash', imageFile);
    }
    if (length) formData.append('length', length);
    if (heigth) formData.append('heigth', heigth);
    if (width) formData.append('width', width);
    if (weight) formData.append('weight', weight);
    if (weight_unit) formData.append('weight_unit', weight_unit);
    if (dimension_unit) formData.append('dimension_unit', dimension_unit);
    formData.append('batch_active', batch_active ? '1' : '0');
    if (batch_active && batch_type) formData.append('batch_type', batch_type);
    if (tenantChildId) {
      formData.append('team_id', String(tenantChildId));
    }
    for (const [key, value] of formData.entries()) {
      console.log('FormData:', key, value);
    }
    return this.httpClient.post<any>('/products', formData, true, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async updateProduct(
    productId: string | number,
    {
      name,
      description,
      code,
      cost,
      categoryId,
      imageFile,
      length,
      heigth,
      width,
      weight,
      weight_unit,
      dimension_unit,
      batch_active,
      batch_type,
    }: {
      name: string;
      description: string;
      code: string;
      cost: number;
      categoryId: string;
      imageFile?: File;
      length?: string;
      heigth?: string;
      width?: string;
      weight?: string;
      weight_unit?: string;
      dimension_unit?: string;
      batch_active?: boolean;
      batch_type?: string;
    },
    /** Respuesta original del GET; si está definida, solo se envían campos que cambiaron */
    initialFromApi?: any,
  ): Promise<any> {
    if (initialFromApi != null) {
      return this.updateProductPatch(productId, {
        name,
        description,
        code,
        cost,
        categoryId,
        imageFile,
        length,
        heigth,
        width,
        weight,
        weight_unit,
        dimension_unit,
        batch_active,
        batch_type,
        initialFromApi,
      });
    }

    const formData = new FormData();
    if (name) formData.append('name', name);
    if (description) formData.append('description', description);
    if (code) formData.append('code', code);
    if (cost !== undefined && cost !== null && cost !== 0) formData.append('cost', String(cost));
    if (categoryId) formData.append('category_id', categoryId);
    if (imageFile) {
      formData.append('image_hash', imageFile);
    }
    if (length) formData.append('length', length);
    if (heigth) formData.append('heigth', heigth);
    if (width) formData.append('width', width);
    if (weight) formData.append('weight', weight);
    if (weight_unit) formData.append('weight_unit', weight_unit);
    if (dimension_unit) formData.append('dimension_unit', dimension_unit);
    formData.append('batch_active', batch_active ? '1' : '0');
    if (batch_active && batch_type) formData.append('batch_type', batch_type);
    for (const [key, value] of formData.entries()) {
      console.log('FormData[PUT]:', key, value);
    }
    return this.httpClient.post<any>(`/products/${productId}`, formData, true, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  private updateProductPatch(
    productId: string | number,
    args: {
      name: string;
      description: string;
      code: string;
      cost: number;
      categoryId: string;
      imageFile?: File;
      length?: string;
      heigth?: string;
      width?: string;
      weight?: string;
      weight_unit?: string;
      dimension_unit?: string;
      batch_active?: boolean;
      batch_type?: string;
      initialFromApi: any;
    },
  ): Promise<any> {
    const {
      name,
      description,
      code,
      cost,
      categoryId,
      imageFile,
      length = '',
      heigth = '',
      width = '',
      weight = '',
      weight_unit = 'kg',
      dimension_unit = 'cm',
      batch_active = false,
      batch_type = '',
      initialFromApi: o,
    } = args;

    const origCategory = o.category_id != null ? String(o.category_id) : '';
    const origWUnit = normStr(o.weight_unit) || 'kg';
    const origDUnit = normStr(o.dimension_unit) || 'cm';
    const origBatchActive = Boolean(o.batch_active);
    const origBatchType = normStr(o.batch_type);

    const formData = new FormData();
    if (name !== normStr(o.name)) formData.append('name', name);
    if (description !== normStr(o.description)) formData.append('description', description);
    if (code !== normStr(o.code)) formData.append('code', code);

    const newCost = numCostForm(String(cost));
    const oldCost = numCostApi(o.cost);
    if (newCost !== oldCost) {
      formData.append('cost', String(newCost));
    }

    if (categoryId !== origCategory && categoryId) {
      formData.append('category_id', categoryId);
    }
    if (imageFile) {
      formData.append('image_hash', imageFile);
    }

    if (normStr(length) !== normStr(o.length)) {
      formData.append('length', length);
    }
    if (normStr(heigth) !== normStr(o.heigth)) {
      formData.append('heigth', heigth);
    }
    if (normStr(width) !== normStr(o.width)) {
      formData.append('width', width);
    }
    if (normStr(weight) !== normStr(o.weight)) {
      formData.append('weight', weight);
    }
    if (weight_unit !== origWUnit) {
      if (weight_unit) formData.append('weight_unit', weight_unit);
    }
    if (dimension_unit !== origDUnit) {
      if (dimension_unit) formData.append('dimension_unit', dimension_unit);
    }

    if (origBatchActive !== batch_active) {
      formData.append('batch_active', batch_active ? '1' : '0');
      if (batch_active && batch_type) {
        formData.append('batch_type', batch_type);
      }
    } else if (batch_active && origBatchType !== normStr(batch_type) && batch_type) {
      formData.append('batch_type', batch_type);
    }

    if ([...formData.keys()].length === 0) {
      return { id: productId } as any;
    }

    for (const [key, value] of formData.entries()) {
      console.log('FormData[PUT patch]:', key, value);
    }
    return this.httpClient.post<any>(`/products/${productId}`, formData, true, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async adjustStock({
    locationId,
    productId,
    quantity,
    description,
    batchId,
  }: {
    locationId: string | number;
    productId: string | number;
    quantity: number;
    description: string;
    batchId?: number;
  }): Promise<any> {
    return this.httpClient.post<any>(`/stock-event/adjust-stock`, {
      product_id: productId,
      qty: quantity,
      location_id: locationId,
      description,
      ...(batchId && { batch_id: batchId }),
    });
  }

  async createLink({
    productId,
    externalProductId,
    externalVariantId,
    shopId,
  }: {
    productId: string | number;
    externalProductId: string | number;
    externalVariantId?: string | number | null;
    shopId: string | number;
  }): Promise<any> {
    const payload: any = {
      product_id: productId,
      external_product_id: externalProductId,
      shop_id: shopId,
    };

    // Incluir external_variant_id si se proporciona (ya sea de variante seleccionada o variant_id del producto)
    if (externalVariantId !== undefined && externalVariantId !== null) {
      payload.external_variant_id = externalVariantId;
    }

    return this.httpClient.post<any>('/products/external/link', payload);
  }

  /**
   * Vincular producto con SKU de Amazon (FBM)
   * POST /products/external/link/amazon-sku
   */
  async linkAmazonSku({
    productId,
    externalVariantId,
    shopId,
  }: {
    productId: string | number;
    externalVariantId: string;
    shopId: string | number;
  }): Promise<any> {
    return this.httpClient.post<any>('/products/external/link/amazon-sku', {
      product_id: productId,
      external_variant_id: externalVariantId,
      shop_id: shopId,
    });
  }

  async verifyExternalLink({
    productId,
    externalProductId,
    externalVariantId,
    shopId,
  }: {
    productId: string | number;
    externalProductId: string | number;
    externalVariantId: string | number;
    shopId: string | number;
  }): Promise<any> {
    return this.httpClient.post<any>('products/external/verify', {
      product_id: productId,
      external_product_id: externalProductId,
      external_variant_id: externalVariantId,
      shop_id: shopId,
    });
  }

  async deleteExternalLink(linkedProductId: string | number): Promise<void> {
    await this.httpClient.delete(`/products/external/link/${linkedProductId}`);
  }

  async getById(productId: string | number): Promise<any> {
    return this.httpClient.get<any>(`/products/${productId}`);
  }

  async hasStockMovements(productId: string | number): Promise<boolean> {
    const response = await this.httpClient.get<any>(
      '/stock-movement',
      {
        product_ids: String(productId),
        page: 1,
        per_page: 1,
        order_by: 'id',
        order_direction: 'desc',
      },
      {},
      false,
    );
    const total = response?.meta?.total ?? 0;
    return total > 0;
  }

  async getLastCreatedProduct(): Promise<any> {
    const resp = await this.httpClient.get<any>('/products?per_page=1&order_by=id&order_direction=desc');
    if (resp && Array.isArray(resp.data) && resp.data.length > 0) {
      return resp.data[0];
    }
    return null;
  }
}
